export enum GenericExpandablePropertyType {
  DOCUMENTS = 'Documents'
}

export enum VehicleExpandablePropertyType {
  ASSIGNED_EMPLOYEE = 'AssignedEmployee',
  ODOMETER_READING = 'OdometerReading',
  DIMENSION_SPECIFICATIONS = 'DimensionSpecifications',
  FUEL_ECONOMY_SPECIFICATIONS = 'FuelEconomySpecifications',
  ENGINE_SPECIFICATIONS = 'EngineSpecifications',
  WHEELS_AND_TIRES_SPECIFICATIONS = 'WheelsAndTiresSpecifications',
  DOCUMENTS = 'Documents'
}

export enum MachineExpandablePropertyType {
  ASSIGNED_EMPLOYEE = 'AssignedEmployee',
  ODOMETER_READING = 'OdometerReading',
  DIMENSION_SPECIFICATIONS = 'DimensionSpecifications',
  FUEL_ECONOMY_SPECIFICATIONS = 'FuelEconomySpecifications',
  ENGINE_SPECIFICATIONS = 'EngineSpecifications',
  WHEELS_AND_TIRES_SPECIFICATIONS = 'WheelsAndTiresSpecifications',
  DOCUMENTS = 'Documents'
}

export enum JobExpandablePropertyType {
  SCHEDULE = 'Schedule',
  JOB = 'Job',
  DATA = 'Data',
  ASSIGNED_EMPLOYEES = 'Employees',
  ASSIGNED_EMPLOYEES_EMPLOYEE = 'Employees.Employee',
  WORK_ORDER_VENDOR = 'WorkOrderVendor',
  ISSUE_REPORTER = 'IssueReporter',
  ASSET = 'Asset',
  ASSET_INFO = 'AssetInfo',
  ASSET_VEHICLE = 'Asset.Vehicle',
  ASSET_EQUIPMENT = 'Asset.Equipment',
  ASSET_MACHINE = 'Asset.Machine',
  MAINTENANCE_TYPES = 'MaintenanceTypes',
  TASK_TEMPLATES = 'TaskTemplates',
  TASK_TEMPLATES_SECTIONS = 'TaskTemplates.Sections',
  DOCUMENTS = 'Documents',
  NEXT_TRIGGER_INFO = 'NextTriggerInfo'
}

export enum JobTasksExpandablePropertyType {
  DATA = 'Data',
  DATA_SECTIONS = 'Data.Sections',
  EMPLOYEES = 'Employees',
  EMPLOYEES_EMPLOYEE = 'Employees.Employee',
  JOB = 'Job',
  ASSET_INFO = 'AssetInfo',
  DOCUMENTS = 'Documents'
}

export enum JobScheduleExpandablePropertyType {
  ASSETS = 'Asset',
  ASSET_INFO = 'AssetInfo',
  MAINTENANCE_TYPES = 'MaintenanceTypes',
  ASSETS_VEHICLE = 'Asset.Vehicle',
  ASSETS_EQUIPMENT = 'Asset.Equipment',
  ASSETS_MACHINE = 'Asset.Machine',
  ASSIGNED_EMPLOYEES = 'Employees',
  ASSIGNED_EMPLOYEES_EMPLOYEE = 'Employees.Employee',
  WORK_ORDER_VENDOR = 'WorkOrderVendor',
  TASK_TEMPLATES = 'TaskTemplates',
  DOCUMENTS = 'Documents',
  NEXT_TRIGGER_INFO = 'NextTriggerInfo'
}

export enum JobActivitiesExpandablePropertyType {
  JOB_TASK = 'JobTask',
  JOB_TASK_JOB = 'JobTask.Job',
  USER = 'User'
}

export enum EmployeeExpandablePropertyType {
  ADDRESS = 'Address',
  NEXT_OF_KIN = 'NextOfKinDetail'
}
